var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"order-date"},[_c('p',{staticClass:"order-date__year"},[_vm._v(_vm._s(_vm.date))]),_c('p',{staticClass:"order-date__time"},[_vm._v(_vm._s(_vm.time))])])
}
var staticRenderFns = []

export { render, staticRenderFns }